import { FC, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { AdvancedFilterRow, MultiSelectionAdvancedFilter } from 'shared/components/AdvancedFilter';
import { useFilterChangeCallback } from 'shared/hooks';
import { selectBuildingHeatingTypeFilter } from 'shared/selectors/advancedFilters';
import { EBuildingHeatingType } from '../../../../../../../packages/api-models/common/json_query';
import { NonEmptyArray } from '../../../../../../../packages/JsonQuery';

export const BuildingHeatingTypeContainer: FC = () => {
  const { label, value, options } = useSelector(selectBuildingHeatingTypeFilter);

  const onChange = useFilterChangeCallback();

  const handleBuildingHeatingTypeChange = useCallback(
    (newValue: NonEmptyArray<EBuildingHeatingType> | null) => {
      onChange({ action: 'setBuildingHeatingType', arguments: [newValue] });
    },
    [onChange],
  );

  return (
    <AdvancedFilterRow label={label}>
      <MultiSelectionAdvancedFilter value={value} options={options} onFilterChange={handleBuildingHeatingTypeChange} />
    </AdvancedFilterRow>
  );
};
